import { forwardRef, useEffect, useRef, useState } from "react";
import { IdentityQRPng } from "@/components/identity/IdentityQR";
import { renderMeetingBackground } from "@/features/assets/background/renderMeetingBackground";

// Full-resolution 1920x1080 canvas, displayed scaled to its container.
export const MeetingBackgroundCanvas = forwardRef(function MeetingBackgroundCanvas({ identity, templateId, testId = "meeting-background-canvas", onRendered }, ref) {
  const local = useRef(null);
  const canvasRef = ref || local;
  const [qrCanvas, setQrCanvas] = useState(null);
  const needsQr = Boolean(identity.qrValue);

  useEffect(() => {
    if (!canvasRef.current || (needsQr && !qrCanvas)) return;
    let active = true;
    renderMeetingBackground(canvasRef.current, identity, { templateId, qrCanvas }).then(() => active && onRendered?.());
    return () => {
      active = false;
    };
  }, [identity, templateId, qrCanvas, needsQr]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <IdentityQRPng value={identity.qrValue} onReady={(_, c) => setQrCanvas(c)} />
      <canvas ref={canvasRef} data-testid={testId} className="block aspect-video h-auto w-full rounded-lg shadow-[0_24px_40px_-20px_rgba(0,0,0,0.35)]" />
    </>
  );
});
